import { useState, useEffect } from 'react';

const useImageDownloader = (imageUrl, placeholderUrl) => {
  const [imgSrc, setImgSrc] = useState(placeholderUrl);

  useEffect(() => {
    const fetchImage = async () => {
      try {
        const response = await fetch(imageUrl);
        if (!response.ok) throw new Error('Image not found');
        const blob = await response.blob();
        const url = URL.createObjectURL(blob);
        setImgSrc(url);
      } catch (error) {
        setImgSrc(placeholderUrl);
      }
    };

    if (imageUrl) {
      fetchImage();
    }
  }, [imageUrl, placeholderUrl]);

  return imgSrc;
};

export default useImageDownloader;
